import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import SizeGuideContent from './SizeGuideContent';
import { InitialUrlSearchParams } from 'src/scripts/utils/environment';
import { Tab, Tabs } from '@material-ui/core';

const SizeGuidePage = () => {
  const category = InitialUrlSearchParams.get('type') || 'tops';
  const genderFromURLParam = InitialUrlSearchParams.get('gender');

  const [gender, setGender] = useState<'men' | 'women'>(genderFromURLParam === 'men' ? 'men' : 'women');

  return (
    <div className="size-guide-page">
      <div className="size-guide-container">
        <div className="size-guide-header">
          <div className="size-guide-title h2 uppercase center">Size Guide</div>
          <Tabs
            className="size-guide-tabs"
            TabIndicatorProps={{ style: { backgroundColor: 'var(--primary)' } }}
            value={gender}
          >
            <Tab
              className={`item ${gender === 'women' ? 'active' : ''}`}
              label={<span className="h4 uppercase">women</span>}
              value="women"
              onClick={() => {
                setGender('women');
              }}
            />
            <Tab
              className={`item ${gender === 'men' ? 'active' : ''}`}
              label={<span className="h4 uppercase">men</span>}
              value="men"
              onClick={() => {
                setGender('men');
              }}
            />
          </Tabs>
        </div>
        <SizeGuideContent gender={gender} category={category} />
      </div>
    </div>
  );
};

export default SizeGuidePage;

const mountNode = document.querySelector('[react-render-target="size-guide-page"]');
mountNode ? ReactDOM.render(<SizeGuidePage />, mountNode) : console.warn('missing render target: SizeGuidePage');
